module.exports = __webpack_public_path__ + "img/zoom_out.8cde7f0d.svg";